import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import styles from "./Css/Project.module.css";
import { BsGithub, BsLink45Deg } from "react-icons/bs";


export default function Projects() {
  React.useEffect(() => {
    Aos.init({
      duration: 1000,
      anchorPlacement: "center-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  });

  //only one data it can handle
  // const data = {
  // id: 1,
  // title: "Plural sight App-Clone",
  // description:
  //   "This is a clone App of Plural-sight this site provided online education services to its users they provide services in multiple subjects like web development, Manufacturing, business, etc. Clone App is responsive as well as search, sort, filter, pagination, and functionality in it.",
  // githubLink:
  //   "https://github.com/AshishKohad27/changeable-anger-4325/tree/main/changeable-anger-4325",
  // deployLink:
  //   "https://6349ceead81dce0b9c2fa28a--plurasiteashishkohad27.netlify.app/",
  // techStack: ["HTML", "CSS", "JS", "React", "JSON", "Chakra"],
  // coverImage: "/image/PluralSightWeb.PNG",
  // status: "Individual",
  // teamMembers: [
  //   {
  //     avatar: "https://avatars.githubusercontent.com/u/107983345?s=64&v=4",
  //     avatarName: "Ashish Kohad",
  //   },
  // ],
  // type: "Service",
  // };

  const data = {
    "id": 1,
    "title": "MedsPharma",
    "description": "This is a clone of India's most trusted online pharmacy & medical website PharmEasy, we have named it as MedaPharma its as an e-commerce platform, offering pharmaceutical and healthcare products, where users can purchase medicines.",
    "githubLink": "https://github.com/AkashPanda1701/jagged-walk-7134",
    "deployLink": "https://meds-pharma-front-end.vercel.app/",

    "techStack": ["HTML", "CSS", "JS", "React", "Chakra", "Mongo", "NextJs"],
    "coverImage": "https://indoleads.com/wp-content/uploads/2021/10/26a4f9cd35eb7.png",
    "status": "Collaborative",
    "teamMembers": [
      {
        "avatar": "https://avatars.githubusercontent.com/u/107983345?s=64&v=4",
        "avatarName": "Ashish Kohad"
      },
      {
        "avatar": "https://avatars.githubusercontent.com/u/97351159?v=4",
        "avatarName": "Janhavi Prabhu"
      },
      {
        "avatar": "https://avatars.githubusercontent.com/u/107460709?v=4",
        "avatarName": "Akash kumar Panda"
      },
      {
        "avatar": "https://avatars.githubusercontent.com/u/97455677?v=4",
        "avatarName": "Mohd Monish"
      },
      {
        "avatar": "https://avatars.githubusercontent.com/u/103977955?v=4",
        "avatarName": "SHALINI"
      }
    ],
    "type": "Service"
  }

  return (
    <Box maxW="1348px" className={styles.projectContainer} mt="0px"

    >
      <Heading
        as="h1"
        id="projects"
        fontSize={{ base: "80px", sm: "140px", md: "220px" }}
        color={useColorModeValue("gray.300", "gray.600")}
        className={styles.projectHeading}
        fontFamily="'Playfair Display', serif"
      >
        Project
      </Heading>

      <SimpleGrid
        maxW="1248px"
        columns={{ base: 1, sm: 1, md: 1 }}
        spacing="0px"
        h="auto"
        m="auto"
        mt={{ base: "-30px", sm: "-90px", md: "-90px" }}
      >
        <Box height="auto" className={styles.Project1}>
          <SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} spacing="0px">
            <Box
              // data-aos="fade-right"
              // data-aos-easing="ease-in-out"
              // bg="teal.300"
              height="auto"
              className={styles.ProjectRight}
            >
              <Image
                height="500px"
                w="620px"
                data-aos="flip-down"
                data-aos-easing="ease-in-out"
                src={data.coverImage}
              />
            </Box>

            <Box
              // data-aos="fade-left"
              // data-aos-easing="ease-in-out"
              // bg="red.200"
              height="auto"
              className={styles.ProjectLeft}
            >
              <Box>
                <button className={styles.pipe}>{data.status}</button>
              </Box>

              <SimpleGrid
                className={styles.TechStack}
                columns={{ base: 5, sm: 6, md: 6 }}
                spacing="10px"
              >
                {data.techStack.map((ele) => (
                  <Box bg="#2B6CB0" height="30px">
                    {ele}
                  </Box>
                ))}
              </SimpleGrid>

              <Heading as="h1">{data.title}</Heading>

              <Text as="p">{data.description}</Text>

              <AvatarGroup
                size="md"
                max={data.teamMembers.length}
                className={styles.AvatarProfile}
                mt="10px"
              >
                {data.teamMembers.map((team) => (
                  <Avatar name={team.avatarName} src={team.avatar} />
                ))}
              </AvatarGroup>

              <Box className={styles.githubButton} mb="50px">
                <Box>
                  <Link href={data.githubLink} target="_blank">
                    <Button>
                      Github{" "}
                      <span>
                        {" "}
                        <BsGithub />
                      </span>{" "}
                    </Button>
                  </Link>
                </Box>

                <Box>
                  <Link href={data.deployLink} target="_blank">
                    <Button>
                      Deployment{" "}
                      <span>
                        <BsLink45Deg />
                      </span>{" "}
                    </Button>
                  </Link>
                </Box>
              </Box>
            </Box>
          </SimpleGrid>
        </Box>
      </SimpleGrid>
    </Box>
  );
}
